import React from 'react';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  return (
    <div className='footer'>
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-logo">
            <img src="/logo.webp" alt="Mahadev" />
            <p>India's No.1 sports ID provider </p>
          </div>
        </div>
        <div className="footer-section">
          <h3>OUR SERVICES</h3>
          <ul>
            <li><Link to="/sports-id">Sports ID</Link></li>
            <li><Link to="/blogs">Blogs</Link></li>
            <li><Link to="/platforms">Platforms</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>COMPANY</h3>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>LEGAL</h3>
          <ul>
            <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/disclaimer">Disclaimer</Link></li>
          </ul>
        </div>
        <img
          src="/legal.png"
          alt="Mahadev"
          style={{
            marginBottom: '10px',
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '80%',
            height: '150px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        />
        <p style={{
          color: '#DAA520',
          marginLeft: 'auto',
          marginRight: 'auto',
        }} >To play, please ensure that you are at least 18 years old.</p>

      </div>
      <hr className='hr' />
      <div className="footer-bottomsection">
        <div className="footer-copyright">
          <p>&copy; 2025 <Link to="/">Mahadev Book Official</Link>. All rights reserved. Unauthorized reproduction or distribution of any content on this website is prohibited.</p>
        </div>
        <div className="footer-social">
          <Link to={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon" >
            <i className="fab fa-whatsapp"></i>
          </Link>
          <Link to={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon" >
            <i className="fab fa-instagram"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
